import ApiEndpointConstants from '../constants/api/ApiEndpointConstants';
import api from './STORY_BASE_API';

export const fetchCommentList = (params) => {
    return api.post(
        `${ApiEndpointConstants.STORY_COMMENT_LIST}`,
        params,
    );
}
